import { Form, Input } from "decorator-form";

import { ID } from "common/entities/IEntity";
import { ICondition } from "common/form/fields/condition/IConditionType";
import { IKeyValuePair } from "common/form/fields/KeyValueListField";
import InputType from "common/form/InputType";

// tslint:disable:variable-name

/**
 * common properties for all panels.
 *
 * all names prefixed with "__" to avoid collision with panel specific fields.
 */

@Form({title: "General Panel Configuration"})
export default class PanelGeneralConfig {

	@Input({type: InputType.TEXT, title: "Edit Name (Internal)"})
	public __editName?: string;

	@Input({type: InputType.CHECKBOX, title: "Show Border"})
	public __border?: boolean;

	@Input({type: InputType.TEXT, title: "Display Title"})
	public __title?: string;

	// @Input({type: InputType.GROUPS, title: "Groups Allowed"})
	public __groupsAllowed?: ID[];

	// @Input({type: InputType.ROLES, title: "Roles Allowed"})
	public __rolesAllowed?: ID[];

	public __group: string;

	@Input({type: InputType.CONDITION_REMOTE, title: "Remote Condition"})
	public __conditionTree?: string;

	@Input({type: InputType.CONDITION, title: "Permissions"})
	public __permissions?: ICondition;

	@Input({type: InputType.KEY_VALUE_LIST, title: "Attributes"})
	public __attrs?: IKeyValuePair[];

}



// WEBPACK FOOTER //
// ./src/core/components/editor/panels/PanelGeneralConfig.ts